export const TranslationsPlatform = {
  WEB: 'web',
  APP: 'app',
}
